/**
 * @author Swathi
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import { connect } from 'react-redux';
import { Form, message, Select, Button } from 'antd';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useState, useRef } from 'react';
import InputComponent from '../../../Widgets/InputComponent';

import {
  getDeviceList,
  // getOrganisationsList,
  getSitesList,
  submitWorkOrder,
  getJobPlansList,
  getLocationByAsset,
  getWorkTypes,
  getStatus,
  getWorkOrderById
} from '../../../Utils/FormCalls';
import { StyledBox, StyledBoxHeader } from '../../../CSS/style';
import { StyledHomepageSides } from '../../../../../commons/styles/layout';

const { Option } = Select;

const AssetMasterForm = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  // const [organisationsList, setOrganisationsList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);
  const [, setStatusList] = useState([]);
  const [, setFileData] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const workOrderRef = useRef();



  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        const deviceListResponse = await getDeviceList();
        setDeviceList(deviceListResponse.data);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      // try {
      // const organisationsListResponse = await getOrganisationsList();
      // setOrganisationsList(organisationsListResponse.data);
      // } catch (error) {
      // message.warning(`${error.message}`);
      // }
      try {
        const sitesListResponse = await getSitesList();
        setSitesList(sitesListResponse.data);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        const jobPlansListResponse = await getJobPlansList('Active');
        setWorkTypesList(jobPlansListResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        const workTypesResponse = await getWorkTypes();
        setWorkTypesList(workTypesResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        const statusResponse = await getStatus();
        setStatusList(statusResponse);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && props.formObject !== undefined && Object.keys(props.formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
      if (workOrderRef.current) {
        workOrderRef.current.setFieldsValue(props.formObject);
      }
    }
  }, [props.formObject, props.translationCache]);

  const _getDataById = async () => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/InventoryDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      formObject = await getWorkOrderById(base64_decode(path[1]));
    }
    if (formObject) {
      setFormObject(formObject);
      if (workOrderRef.current) {
        workOrderRef.current.setFieldsValue(formObject);
      }
    }
  };
  const handleChange = async (e, key) => {
    const value = e;

    let updatedFormObject = {
      ...formObject,
      [key]: value
    };
    if (key === 'DeviceId') {
      let selectedDevice = deviceList.find(item => item.Id === value);
      let location = await getLocationByAsset(selectedDevice);
      updatedFormObject = {
        ...updatedFormObject,
        LocationId: location.data.Name
      };
    }
    workOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const fileupload = async (values, key) => {
    // Get the current form values
    let currentFormObject = workOrderRef.current.getFieldsValue();

    // Check if the key already exists in the form object
    if (currentFormObject[key]) {
      currentFormObject[key].push(...values);
    } else {
      currentFormObject[key] = values;
    }

    // Remove duplicates based on the 'Name' property
    currentFormObject[key] = currentFormObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    // Update the form object
    currentFormObject = {
      ...currentFormObject,
      [key]: currentFormObject[key]
    };

    // Set the updated values back to the form
    workOrderRef.current.setFieldsValue(currentFormObject);

    // Update the state for formObject and fileData
    setFormObject(currentFormObject);
    setFileData(values); // Assuming you want to set the new file data
  };
  const onFormsubmit = async () => {
    let userId = props.userProfile?.user?.Id || '';
    let updatedFormObject = {
      ...formObject,
      ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
      ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
    };
    let statusResponse = await submitWorkOrder(updatedFormObject);
    if (statusResponse && statusResponse.message) {
      await _getDataById();
      message.success('WorkOrder Submitted Successfully');
      props.navigate('/rubus/AMM/InventoryList');
      onReset();
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    workOrderRef.current.resetFields();
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  return (
    <StyledHomepageSides>
      <Form
        name="Inventory"
        ref={workOrderRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject || {}}
        layout="vertical"
      >

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBoxHeader>
          <StyledBox>

            <Form.Item

              label={translation(constant.item)}
              name="Item"
              rules={[{ required: true, message: translation('Please Input Item!') }]}
            >
              <InputComponent
                placeholder={translation(constant.inputItem)}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Item')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.site)}
              name="Site"
              rules={[{ required: true, message: translation('Please Input Site!') }]}
            >
              <InputComponent
                placeholder={translation('Input Site')}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Site')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.issueUnit)}
              name="Issue Unit"
            >
              <InputComponent
                placeholder={translation('Input Issue Unit')}
                disabled={true}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Issue Unit')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.availableBalanceSummary)}
              name="Available Balance Summary"
            >
              <InputComponent
                placeholder={translation(constant.inputAvailSummary)}
                disabled={true}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Available Balance Summary')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.currentBalance)}
              name="Current Balance"
              rules={[{ required: true, message: translation('Please Input Current Balance!') }]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation('Select Current Balance')}
                onChange={(e) => handleChange(e, 'Current Balance')}
              >
                {sitesList && sitesList !== undefined && sitesList.map((site, index) => (
                  <Option key={index} value={site.Id}>
                    {site.Name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item

              label={translation(constant.quantityCurrentlyReserved)}
              name="Quantity Currently Reserved"
              rules={[{ required: true, message: translation('Please Input Quantity Currently Reserved!') }]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation('Select Quantity Currently Reserved')}
                onChange={(e) => handleChange(e, 'Quantity Currently Reserved')}
              >
                {workTypesList.map((workType, index) => (
                  <Option key={index} value={workType.Id}>
                    {translation(workType.WorkType)}
                  </Option>
                ))}
              </ Select>
            </Form.Item>
            <Form.Item

              label={translation(constant.serialNo)}
              name="Serial No"
              rules={[{ required: true, message: translation('Please Serial No!') }]}
            >
              <Select
                style={{ width: '100%' }}
                placeholder={translation('Select Serial No')}
                onChange={(e) => handleChange(e, 'Serial No')}
              >
                {workTypesList.map((workType, index) => (
                  <Option key={index} value={workType.Id}>
                    {translation(workType.WorkType)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item

              label={translation(constant.lastIssueDate)}
              name="Last Issue Date"
              rules={[{ required: true, message: translation('Please Input Last Issue Date!') }]}
            >
              <InputComponent
                placeholder={translation('Input Last Issue Date')}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Last Issue Date')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.quantityAvailable)}
              name="Quantity Available"
              rules={[{ required: true, message: translation('Please Input Quantity Available!') }]}
            >
              <InputComponent
                placeholder={translation('Input Quantity Available')}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Quantity Available')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.reorderDetails)}
              name="Reorder Details"
              rules={[{ required: true, message: translation('Please Input Reorder Details!') }]}
            >
              <InputComponent
                placeholder={translation('Input Reorder Details')}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Reorder Details')}
              />
            </Form.Item>
            <Form.Item

              label={translation(constant.reorderPoint)}
              name="Reorder Point"
              rules={[{ required: true, message: translation('Please Input Reorder Point!') }]}
            >
              <InputComponent
                placeholder={translation('Input Reorder Point')}
                style={{ width: '100%' }}
                onChange={(e) => handleChange(e, 'Reorder Point')}
              />
            </Form.Item>
            <Form.Item
              name="Attachments"

              label={translation(constant.attachments)}
            >
              <FileBase64
                downloadClassName={'formdownloadInput'}
                Attachments={formObject && formObject.Attachments}
                fileUpload={fileupload}
              />
            </Form.Item>
            <Form.Item name="Id"></Form.Item>
          </StyledBox>
        </StyledBoxHeader>
      </Form>
    </StyledHomepageSides>
  );
};

const mapStateToProps = (state) => ({
  themeValue: state.ThemeReducer,
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile,
});

export default connect(mapStateToProps)(AssetMasterForm);